import {
  SUCCESS,
  FAIL,
  GET_STAKEHOLDERS,
  GET_STAKEHOLDER,
  GET_STAKEHOLDER_FORM_DATA,
  CREATE_STAKEHOLDER,
  UPDATE_STAKEHOLDER,
  DELETE_STAKEHOLDER,
  CLEAR_STAKEHOLDER_DATA,
} from "../action_types";

const initialState = {
  isLoading: false,
  isSaving: false,
  stakeholders: [],
  selectedStakeholder: null,
  formData: null,
  error: {},
};

const stakeholderReducer = (state = initialState, action) => {
  switch (action.type) {
    // Get Stakeholders
    case GET_STAKEHOLDERS:
      return {
        ...state,
        isLoading: true,
        error: {},
      };
    case `${GET_STAKEHOLDERS}_${SUCCESS}`:
      return {
        ...state,
        isLoading: false,
        stakeholders: action.payload.stakeholders || [],
      };
    case `${GET_STAKEHOLDERS}_${FAIL}`:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    // Get Single Stakeholder
    case GET_STAKEHOLDER:
      return {
        ...state,
        isLoading: true,
        error: {},
      };
    case `${GET_STAKEHOLDER}_${SUCCESS}`:
      return {
        ...state,
        isLoading: false,
        selectedStakeholder: action.payload,
      };
    case `${GET_STAKEHOLDER}_${FAIL}`:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    // Get Form Data
    case GET_STAKEHOLDER_FORM_DATA:
      return {
        ...state,
        isLoading: true,
        error: {},
      };
    case `${GET_STAKEHOLDER_FORM_DATA}_${SUCCESS}`:
      return {
        ...state,
        isLoading: false,
        formData: action.payload,
      };
    case `${GET_STAKEHOLDER_FORM_DATA}_${FAIL}`:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    // Create Stakeholder
    case CREATE_STAKEHOLDER:
      return {
        ...state,
        isSaving: true,
        error: {},
      };
    case `${CREATE_STAKEHOLDER}_${SUCCESS}`:
      return {
        ...state,
        isSaving: false,
        stakeholders: [...state.stakeholders, action.payload],
      };
    case `${CREATE_STAKEHOLDER}_${FAIL}`:
      return {
        ...state,
        isSaving: false,
        error: action.payload,
      };

    // Update Stakeholder
    case UPDATE_STAKEHOLDER:
      return {
        ...state,
        isSaving: true,
        error: {},
      };
    case `${UPDATE_STAKEHOLDER}_${SUCCESS}`:
      return {
        ...state,
        isSaving: false,
        stakeholders: state.stakeholders.map((s) =>
          s.id === action.payload.id ? action.payload : s
        ),
        selectedStakeholder:
          state.selectedStakeholder?.id === action.payload.id
            ? action.payload
            : state.selectedStakeholder,
      };
    case `${UPDATE_STAKEHOLDER}_${FAIL}`:
      return {
        ...state,
        isSaving: false,
        error: action.payload,
      };

    // Delete Stakeholder
    case DELETE_STAKEHOLDER:
      return {
        ...state,
        isSaving: true,
        error: {},
      };
    case `${DELETE_STAKEHOLDER}_${SUCCESS}`:
      return {
        ...state,
        isSaving: false,
        stakeholders: state.stakeholders.filter(
          (s) => s.id !== action.payload.stakeholderId
        ),
        selectedStakeholder:
          state.selectedStakeholder?.id === action.payload.stakeholderId
            ? null
            : state.selectedStakeholder,
      };
    case `${DELETE_STAKEHOLDER}_${FAIL}`:
      return {
        ...state,
        isSaving: false,
        error: action.payload,
      };

    // Clear Data
    case CLEAR_STAKEHOLDER_DATA:
      return {
        ...state,
        selectedStakeholder: null,
        formData: null,
        error: {},
      };

    default:
      return state;
  }
};

export default stakeholderReducer;

